export enum AccountConnectionStatus {
    NotConnected = 'NotConnected',
    Connected = 'Connected',
    PendingDisconnect = 'PendingDisconnect',
    Disconnected = 'Disconnected',
    PendingReconnect = 'PendingReconnect',
}
